import { Col, PageWrapper, Row } from '@qonsoll/react-design'

import { NewsTipOneStepCreation } from 'domains/NewsTip/components'
import { useTranslations } from 'contexts/Translation'

const NewsTipWizardPage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()

  /* Configuring page header */
  const headingProps = {
    title: t('Enter the tip'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'center'
  }

  return (
    <PageWrapper headingProps={headingProps}>
      <Row noGutters h="center">
        <Col cw={12}>
          <NewsTipOneStepCreation isGuestMode={true} />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default NewsTipWizardPage
